import clsx from 'clsx';
import { forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import Icon from '@mui/material/Icon';
import { number, string } from 'yup';

interface FuseSvgIconProps {
  children?: string; // SVG ikonkalar uchun
  size?: number | string; // Belgilangan o'lcham
  sx?: object; // Material-UI sx (CSS xususiyatlari)
  color?: 'inherit' | 'disabled' | 'primary' | 'secondary' | 'action' | 'error' | 'info' | 'success' | 'warning';
  className?: string; // Qo'shimcha class nomlar
}

const Root = styled(Box)<{ size: number | string, color: string, fill?: string, xmlns?: string, viewBox?: string }>(({
                                                                                                                       theme,
                                                                                                                       size,
                                                                                                                       color,
                                                                                                                       fill,
                                                                                                                       xmlns,
                                                                                                                       viewBox,
                                                                                                                     }) => ({
  width: size,
  height: size,
  minWidth: size,
  minHeight: size,
  fontSize: size,
  lineHeight: size,
  color: {
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    info: theme.palette.info.main,
    success: theme.palette.success.main,
    warning: theme.palette.warning.main,
    action: theme.palette.action.active,
    error: theme.palette.error.main,
    disabled: theme.palette.action.disabled,
    inherit: undefined,
  }[color],
}));

const FuseSvgIcon = forwardRef<SVGSVGElement | HTMLElement, FuseSvgIconProps>(
  ({ children = '', size = 24, sx = {}, color = 'inherit', className, ...props }, ref) => {
    if (!children.includes(':')) {
      return <Icon ref={ref as any} {...props} />;
    }

    const iconPath = children.replace(':', '.svg#');

    return (
      <Root
        {...props}
        component="svg"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        className={clsx('shrink-0 fill-current ', className)}
        ref={ref as any}
        size={size}
        sx={sx}
        color={color}
      >
        <use xlinkHref={`assets/icons/${iconPath}`} />
      </Root>
    );
  },
);

export default FuseSvgIcon;
